import client from './client';
import administration from './administration';
import project from './project';
import personalLanguage from './personalLanguage';
import fvs from './fvs';
import fvz from './fvz';
import order from './order';
import report from './report';
import menuNavigation from './menu';
import application from './application';
import excelImport from './excelImport';
import common from './common';
import role from './role';
import validation from './validation';
import enumObjects from './enumObjects';

export const enumLng = {
  ...enumObjects,
};

export const menuLng = {
  ...menuNavigation,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const commonLng = {
  ...personalLanguage,
  ...enumObjects,
  ...common,
  ...validation,
};

export const administrationLng = {
  ...administration,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const roleLng = {
  ...role,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const clientLng = {
  ...client,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const projectLng = {
  ...project,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const fvsLng = {
  ...fvs,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const fvzLng = {
  ...fvz,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const orderLng = {
  ...order,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const reportLng = {
  ...report,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const applicationLng = {
  ...application,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};

export const excelImportLng = {
  ...excelImport,
  ...personalLanguage,
  ...enumObjects,
  ...common,
};
